// Fully reusable component in `FormRadioGroup` and `FormCheckboxGroup`
// therefore no need for duplicated tests and stories

import FormSelector from '@atoms/FormSelector/FormSelector';
import { IFormSelectorGroup } from '@models/IFormSelectorGroup';
import { ErrorMessage, useField } from 'formik';

const FormSelectorGroup = ({
  groupClassName,
  name,
  options,
  selectorClassName,
  selectorLabelType,
  type,
  dataTestId = 'Form-Selector-Group',
}: IFormSelectorGroup) => {
  const [, { error, touched }] = useField<string | string[]>(name);
  const isError = !!error && touched;

  return (
    <div>
      <fieldset className={groupClassName}>
        {options.map(({ label, value }) => (
          <div key={value} className={selectorClassName}>
            <FormSelector
              label={label}
              labelType={selectorLabelType}
              name={name}
              showError={false}
              type={type}
              value={value}
              dataTestId={`${dataTestId}-Selector`}
            />
          </div>
        ))}
      </fieldset>

      {isError && (
        <ErrorMessage name={name}>
          {(msg: string) => (
            <span
              className="body-four text-red"
              data-testid="form-select-label"
            >
              {msg}
            </span>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default FormSelectorGroup;
